import { DataDownloadMessages } from '../types';

export const dataDownloadDE: DataDownloadMessages = {
  'app.datadownload.checkbox.study_abroad': 'Auslandsstudium',
  'app.datadownload.checkbox.additional_demographics_info': 'Zusätzliche demografische Daten',
  'app.datadownload.checkbox.remove_anonymous_user': 'Anonyme Nutzer:innen entfernen',
}
